export default {
  storeTicker(context, payload) {
    context.commit('storeTicker', payload);
  },
  storeRadioValue(context, payload) {
    context.commit('storeRadioValue', payload);
  },
};
